import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TagComponent } from '@shared/components/tag/tag.component';
import { SharedModule } from '@shared/modules/shared.module';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-tag',
	imports: [SharedModule, TagComponent, UiCodeBlockComponent],
	templateUrl: './ui-tag.component.html',
	styleUrl: './ui-tag.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTagComponent {
	generateCode(attrs: { label?: string; color?: string; size?: string }): string {
		let code = '<app-tag';

		if (attrs.label) code += `\n    label="${attrs.label}"`;
		if (attrs.color) code += `\n    color="${attrs.color}"`;
		if (attrs.size) code += `\n    size="${attrs.size}"`;

		code += '\n/>';
		return code;
	}
}
